import { render, staticRenderFns } from "./VueActionButtons.vue?vue&type=template&id=60e16d40"
import script from "./VueActionButtons.vue?vue&type=script&lang=js"
export * from "./VueActionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports